export type AdvancedToolKey = 'tutor' | 'community' | 'flashcards' | 'studyPlan' | 'reverse';

export const LEARN_LAUNCH_CONFIG = {
  coreLoop: ['lesson', 'practice', 'review', 'exam'] as const,
  advancedTools: {
    tutor: false,
    community: false,
    flashcards: false,
    studyPlan: false,
    reverse: false,
  } as Record<AdvancedToolKey, boolean>,
};

export const ADVANCED_TOOL_META: Record<AdvancedToolKey, { title: string; whenToUse: string }> = {
  tutor: {
    title: 'מנחה אישי',
    whenToUse: 'השתמשו כשנתקעים בהסבר נקודתי אחרי תרגול, לא במקום השיעור עצמו.',
  },
  community: {
    title: 'קהילת לומדים',
    whenToUse: 'השתמשו לשאלות שאחרי ניסיון עצמאי בתרגול או בסקירת טעויות.',
  },
  flashcards: {
    title: 'כרטיסיות חזרה',
    whenToUse: 'השתמשו לחיזוק זכירה בין סשני תרגול, במיוחד לפני מבחן.',
  },
  studyPlan: {
    title: 'תוכנית לימוד',
    whenToUse: 'השתמשו לתכנון שבועי כשכבר יש לכם קצב קבוע בשיעור ותרגול.',
  },
  reverse: {
    title: 'תרגול ממוקד',
    whenToUse: 'השתמשו רק אחרי שיש היסטוריית טעויות שממנה אפשר לבנות תיקון ממוקד.',
  },
};

export const KURSI_LEARN_STYLE_GUIDE = {
  marketing: 'בטוח, ממוקד תוצאה, בלי הבטחות מוגזמות.',
  onboarding: 'צעד אחד ברור בכל רגע, עם ניסוח קצר ופעיל.',
  runtime: 'מה קורה עכשיו, מה הצעד הבא, ולמה זה חשוב למוכנות.',
  errors: 'מה נכשל, למה זה כנראה קרה, ומה הפעולה הבטוחה הבאה.',
  fallback: 'אם AI או שירות איטי, ממשיכים במסלול הליבה בלי בלבול.',
};
